import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { LOADING_SCREEN_CREATIVE_ID } from 'site-modules/shared/components/personalized-search/personalized-search-loading-screen/personalized-search-loading-screen';

export function fireWidgetViewTracking() {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_WIDGET_VIEW,
    event_data: {
      action_name: TrackingConstant.ACTION_WIDGET_VIEW,
      action_cause: TrackingConstant.ACTION_CAUSE_SCROLL,
      total_page_height: Math.max(document.body.scrollHeight, document.body.offsetHeight),
      creative_id: LOADING_SCREEN_CREATIVE_ID,
    },
  });
}
